"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.geocode = exports.reverseGeocode = void 0;
const GoogleMapsController_1 = __importDefault(require("./GoogleMapsController"));
function reverseGeocode(coordinates, options) {
    return GoogleMapsController_1.default.request('geocode', [['latlng', coordinates.join(',')]], options);
}
exports.reverseGeocode = reverseGeocode;
function geocode(address, options) {
    return GoogleMapsController_1.default.request('geocode', [['address', address]], options);
}
exports.geocode = geocode;
